var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 33C24.3302 33 26.4912 32.2754 28.27 31.0393C28.04 28.1717 25.3207 25.1429 22 25.1429C18.6793 25.1429 15.96 28.1717 15.73 31.0393C17.5088 32.2754 19.6698 33 22 33Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1429 19.6429C25.1429 21.3786 23.7358 22.7857 22 22.7857C20.2642 22.7857 18.8571 21.3786 18.8571 19.6429C18.8571 17.9071 20.2642 16.5 22 16.5C23.7358 16.5 25.1429 17.9071 25.1429 19.6429Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7143 31.4286C15.7143 31.2994 15.7196 31.1695 15.73 31.0393M28.2857 31.4286C28.2857 31.2994 28.2804 31.1695 28.27 31.0393M28.27 31.0393C26.4912 32.2754 24.3302 33 22 33C19.6698 33 17.5088 32.2754 15.73 31.0393M28.27 31.0393C28.04 28.1717 25.3207 25.1429 22 25.1429C18.6793 25.1429 15.96 28.1717 15.73 31.0393M28.27 31.0393C31.1286 29.0527 33 25.7449 33 22C33 15.9249 28.0751 11 22 11C15.9249 11 11 15.9249 11 22C11 25.7449 12.8714 29.0527 15.73 31.0393M25.1429 19.6429C25.1429 21.3786 23.7358 22.7857 22 22.7857C20.2642 22.7857 18.8571 21.3786 18.8571 19.6429C18.8571 17.9071 20.2642 16.5 22 16.5C23.7358 16.5 25.1429 17.9071 25.1429 19.6429Z",
    stroke: "white",
    strokeWidth: 1.83333
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserButton);
export default __webpack_public_path__ + "static/media/User Button.5fb13f6d11613c0ca28a44c9d6a918c3.svg";
export { ForwardRef as ReactComponent };